/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import axios from 'axios';

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import Footer from "../../components/includes/Footer";
import FlyCalling from "../../components/includes/FlyCalling";

import SetupCurrentDate from "../../components/deliverys/SetupCurrentDate";
import DeliveryCard from "../../components/deliverys/DeliveryCard";

import { LoginAfterCheckLogin,ChangeSearchingDateFormat,ChangeDateFormat,isNull } from "../../components/common/Common";

import "../../css/style.css";

//배차목록호출
const DeliveryState = () => {
  LoginAfterCheckLogin(1);  //로그인 상태 점검

  const mem_idx = localStorage.getItem('mem_idx');
  //검색일자
  const [varCurrentDate,setCurrentDate] = useState(new Date());
  const [varCurrentDateTotal,setCurrentDateTotal] = useState(0);
  //배차목록
  const [varDeliveryList,setDeliveryList] = useState([]);

  //배차목록호출
  const GetDeliveryList = async () => {
    const cdate = ChangeSearchingDateFormat(varCurrentDate,'-');
    const sendData = {mem_idx:mem_idx,dc_riding_date:cdate};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_delivery_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setDeliveryList(datas.results);
        const totalcount = datas.results?.length;
        console.log(totalcount);
        setCurrentDateTotal(totalcount);
      }
    });
  }
  //검색날짜가 변경시
  useEffect(() => {
    let nowDate = new Date();
    if(!isNull(localStorage.getItem("setHistoryDate"))) nowDate = new Date(localStorage.getItem("setHistoryDate"));
    setCurrentDate(nowDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //검색날짜가 변경시
  useEffect(() => {
    GetDeliveryList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentDate]);

  //날짜변경
  const onChangeCurrentDateHandler = (e,idays) => {
    e.preventDefault();
    const sdate = varCurrentDate.getDate();
    const nDate = new Date(varCurrentDate.setDate(sdate + idays));
    setCurrentDate(nDate);
    //날짜를 메모리에 별도 저장
    const setDate = ChangeDateFormat(nDate);
    localStorage.setItem("setHistoryDate",setDate);
  }

  return (
    <div className="vh-container">
      <Header varGoToMain={true} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'배차 현황'} varBackString={"delivery"}/>
        <div className="vh-content-body">
          <SetupCurrentDate varCurrentDate={varCurrentDate} onChangeCurrentDateHandler={onChangeCurrentDateHandler} />
          <div className="driving-his-total">총 <strong>{varCurrentDateTotal}</strong>&nbsp;&nbsp;건</div>
          <div className="driving-his-list" style={{marginBottom:"84px"}}>
            {varDeliveryList.map((cars,i)=>(
              <DeliveryCard key={'cars_'+i} varDeliveryData={cars}/>
            ))}
          </div>
        </div>
        <Footer varActiveMode={2}/>
        <FlyCalling />
      </div>
    </div>
  );
}
export default DeliveryState;